import { getUrlDomain } from '../../../../../../../../../helpers/url'

import {
  AD_DESCRIPTION,
  AD_HEADLINE,
  CALL_TO_ACTION,
  CLICK_THROUGH_LINK,
  CUSTOMIZED_STORY_FILE,
  FB_PAGE_CHOICE,
  HEADLINE_ENTER,
  HEADLINE_OPTION,
  INSTA_ACCOUNT_CHOICE,
  INSTAGRAM_ACTOR_ID,
  LEAD_GEN_FORM,
  NAME,
  PRIMARY_TEXT_LIST,
  TEXT_ENTER,
  TEXT_OPTION
} from '../../../../../../fields'
import {
  IMAGE_HASH,
  FILE_ID,
  MEDIA_TYPE,
  VIDEO_PICTURE
} from '../../../../../../../../ReusableFormFields/AdFileUpload/fields'

import { FormatSingleItemWithStoryToBEParams, FormatSingleItemWithStoryToBEResult } from './types'
import {
  THRUPLAY,
  TWO_SECOND_CONTINUOUS_VIDEO_VIEWS
} from '../../../../../../../LineItemForms/LineItemFacebookCreate/LineItemFacebookCreateForm/fields'
import { instagramPositions } from '../../../../../../../constants'

export function formatSingleItemWithStoryToBE({
  values,
  tags,
  selectedAdAccountId,
  lineItem,
  originalAd
}: FormatSingleItemWithStoryToBEParams): FormatSingleItemWithStoryToBEResult {
  const {
    [NAME]: name,
    [MEDIA_TYPE]: mediaType,
    // [AD_TEXT]: adText,
    [AD_HEADLINE]: adHeadline,
    [AD_DESCRIPTION]: adDescription,
    [HEADLINE_OPTION]: headlineOption,
    [TEXT_OPTION]: textOption,
    [VIDEO_PICTURE]: feedVideoPicture,
    [FILE_ID]: feedVideoId,
    [CLICK_THROUGH_LINK]: clickThroughLink,
    [IMAGE_HASH]: fileHash,
    [INSTA_ACCOUNT_CHOICE]: instagramAccountChoice,
    [FB_PAGE_CHOICE]: facebookPageChoice,
    [CALL_TO_ACTION]: callToActionChoice,
    [CUSTOMIZED_STORY_FILE]: customizedStoryFile
  } = values

  const story = customizedStoryFile

  // use first element from primary text list
  const adText = values[PRIMARY_TEXT_LIST]?.[0].text

  const imageHashForStoryImage = story[IMAGE_HASH]
  const storyMediaType = story[MEDIA_TYPE]
  const storyVideoId = story[FILE_ID]
  const storyVideoPicture = story[VIDEO_PICTURE]

  const originalAdFormats = originalAd?.creative?.asset_feed_spec?.ad_formats

  const adFormats = originalAdFormats
    ? // is used in edit form
      originalAdFormats
    : // is used in create form (when we create the ad we need to check the line item objective)
      lineItem?.objective === THRUPLAY || lineItem?.objective === TWO_SECOND_CONTINUOUS_VIDEO_VIEWS
      ? ['SINGLE_VIDEO']
      : ['AUTOMATIC_FORMAT']

  return {
    account_id: selectedAdAccountId,
    // page_id and instagram_user_id should be added in 2 places, do not remove any of them
    actor_id: facebookPageChoice,
    ...(instagramAccountChoice && { [INSTAGRAM_ACTOR_ID]: instagramAccountChoice }),
    name,
    object_type: 'share',
    object_story_spec: {
      // page_id and instagram_user_id should be added in 2 places, do not remove any of them
      page_id: facebookPageChoice,
      ...(instagramAccountChoice && { [INSTAGRAM_ACTOR_ID]: instagramAccountChoice })
    },
    ...(tags && { url_tags: tags }),
    asset_feed_spec: {
      ad_formats: adFormats,
      additional_data: {
        multi_share_end_card: false
      },
      asset_customization_rules: [
        {
          ...(textOption === TEXT_ENTER && {
            body_label: {
              name: 'label_story_primarytext'
            }
          }),
          customization_spec: {
            age_max: '65',
            age_min: '13',
            publisher_platforms: ['facebook', 'instagram', 'messenger'],
            facebook_positions: ['story', 'facebook_reels'],
            messenger_positions: ['story'],
            instagram_positions: instagramPositions
          },
          ...(storyMediaType === 'image'
            ? {
                image_label: {
                  name: 'label_story_image'
                }
              }
            : {
                video_label: {
                  name: 'label_story_video'
                }
              }),
          link_url_label: {
            name: 'label_story_link'
          },
          priority: 1,
          ...(headlineOption === HEADLINE_ENTER && {
            title_label: {
              name: 'label_story_headline'
            }
          })
        },
        {
          ...(textOption === TEXT_ENTER && {
            body_label: {
              name: 'label_other_primarytext'
            }
          }),
          customization_spec: {
            age_max: '65',
            age_min: '13'
          },
          ...(mediaType === 'image'
            ? // MAIN FEED IS AN IMAGE
              {
                image_label: {
                  name: 'label_other_image'
                }
              }
            : // MAIN FEED IS A VIDEO
              {
                video_label: {
                  name: 'label_other_video'
                }
              }),
          link_url_label: {
            name: 'label_other_link'
          },
          priority: 2,
          ...(headlineOption === HEADLINE_ENTER && {
            title_label: {
              name: 'label_other_headline'
            }
          })
        }
      ],

      ...(textOption === TEXT_ENTER && {
        bodies: [
          {
            adlabels: [
              {
                name: 'label_other_primarytext'
              },
              {
                name: 'label_story_primarytext'
              }
            ],
            text: adText
          }
        ]
      }),
      call_to_action_types: [callToActionChoice.toLowerCase()],
      ...(values[LEAD_GEN_FORM] && {
        call_to_actions: [
          {
            type: callToActionChoice,
            value: {
              lead_gen_form_id: values[LEAD_GEN_FORM]
            }
          }
        ]
      }),
      ...(adDescription && { descriptions: [{ text: adDescription }] }),
      // MAIN FEED OR STORY IS AN IMAGE
      ...((mediaType === 'image' || storyMediaType === 'image') && {
        images: [
          // MAIN FEED IS AN IMAGE
          ...(mediaType === 'image'
            ? [
                {
                  adlabels: [
                    {
                      name: 'label_other_image'
                    }
                  ],
                  hash: fileHash
                }
              ]
            : []),
          // STORY IS AN IMAGE
          ...(storyMediaType === 'image'
            ? [
                {
                  adlabels: [
                    {
                      name: 'label_story_image'
                    }
                  ],
                  hash: imageHashForStoryImage
                }
              ]
            : [])
        ]
      }),
      link_urls: [
        {
          adlabels: [
            {
              name: 'label_story_link'
            },
            {
              name: 'label_other_link'
            }
          ],
          caption: getUrlDomain(clickThroughLink),
          website_url: clickThroughLink
        }
      ],
      ...(headlineOption === HEADLINE_ENTER && {
        titles: [
          {
            adlabels: [
              {
                name: 'label_other_headline'
              },
              {
                name: 'label_story_headline'
              }
            ],
            text: adHeadline
          }
        ]
      }),
      // MAIN FEED OR STORY IS A VIDEO
      ...((mediaType === 'video' || storyMediaType === 'video') && {
        videos: [
          // MAIN FEED IS A VIDEO
          ...(mediaType === 'video'
            ? [
                {
                  adlabels: [
                    {
                      name: 'label_other_video'
                    }
                  ],
                  thumbnail_url: feedVideoPicture,
                  video_id: feedVideoId
                }
              ]
            : []),
          // STORY IS A VIDEO
          ...(storyMediaType === 'video'
            ? [
                {
                  adlabels: [
                    {
                      name: 'label_story_video'
                    }
                  ],
                  thumbnail_url: storyVideoPicture,
                  video_id: storyVideoId
                }
              ]
            : [])
        ]
      })
    }
  }
}
